<template>
  <div class="home">
    <div class="content">
      <router-view v-slot="{ Component }">
        <keep-alive>
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </div>
    <div class="tab-box">
      <div class="item">
        <router-link to="/fuli-index">
          <i class="fuli"></i>
          <p>福利</p>
        </router-link>
      </div>
      <div class="item">
        <router-link to="/fanli-index">
          <i class="fanli"></i>
          <p>返利</p>
        </router-link>
      </div>
      <div class="item">
        <router-link to="/xiaoxi-index">
          <i class="xiaoxi"></i>
          <p>消息</p>
        </router-link>
      </div>
      <div class="item">
        <router-link to="/youxi-index">
          <i class="youxi"></i>
          <p>游戏</p>
        </router-link>
      </div>
      <div class="item">
        <router-link to="/wode-index">
          <i class="wode"></i>
          <p>我的</p>
        </router-link>
      </div>
    </div>
    <!-- <p>登录状态：{{state.isLogin}}</p>
    <p>用户昵称：{{state.nickName}}</p>
    <p>渠道id：{{state.channelUid}}</p>
    <p>token：{{state.token}}</p>
    <p>地址参数：{{state.params.gameId}}</p>
    <button @click="onTc">退出登录</button>
    <button @click="onQh">切换小号</button> -->
  </div>
</template>

<script>
  import {
    reactive
  } from 'vue'
  import {
    useStore
  } from 'vuex'
  import utils from '@/utils/utils.js'

  export default {
    name: 'homeIndex',
    setup() {
      const store = useStore()
      const state = reactive({
        isLogin: store.state.isLogin,
        nickName: store.state.userInfo?.nickName,
        channelUid: store.state.userInfo?.channelUid,
        token: store.state.token,
        params: utils.queryURLParams(window.location.href),
      })

      const onTc = () => {
        parent.chk_switchAccount()
      }
      const onQh = () => {
        top.location.href = '/index.php?ac=play&id=' + state.params.gameId
      }
      console.log(state.params.gameId)

      return {
        utils,
        state,
        onTc,
        onQh
      }
    }
  }
</script>

<style lang="less" scoped>
  .home {
    background-color: #fff;
    display: flex;
    flex-direction: column;
    height: 100vh;

    .content {
      flex: 1;
      width: 100%;
      overflow-y: scroll;
      height: 100%;
    }

    .tab-box {
      padding: 18px;
      background-color: #F4F8FB;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .item {
        font-size: 10px;

        a {
          display: block;

          i {
            display: block;
            width: 24px;
            height: 24px;

            &.fuli {
              background: url(../assets/home/ico_tab_1_1.png) no-repeat center top;
              background-size: contain;
            }

            &.fanli {
              background: url(../assets/home/ico_tab_2_1.png) no-repeat center top;
              background-size: contain;
            }

            &.xiaoxi {
              background: url(../assets/home/ico_tab_3_1.png) no-repeat center top;
              background-size: contain;
            }

            &.youxi {
              background: url(../assets/home/ico_tab_4_1.png) no-repeat center top;
              background-size: contain;
            }

            &.wode {
              background: url(../assets/home/ico_tab_5_1.png) no-repeat center top;
              background-size: contain;
            }
          }

          p {
            color: #B7BCC4;
            text-align: center;
          }

          &.router-link-active {
            p {
              color: #FF6E2F;
            }

            .fuli {
              background: url(../assets/home/ico_tab_1_2.png) no-repeat center top;
              background-size: contain;
            }

            .fanli {
              background: url(../assets/home/ico_tab_2_2.png) no-repeat center top;
              background-size: contain;
            }

            .xiaoxi {
              background: url(../assets/home/ico_tab_3_2.png) no-repeat center top;
              background-size: contain;
            }

            .youxi {
              background: url(../assets/home/ico_tab_4_2.png) no-repeat center top;
              background-size: contain;
            }

            .wode {
              background: url(../assets/home/ico_tab_5_2.png) no-repeat center top;
              background-size: contain;
            }
          }
        }
      }
    }
  }

  @media screen and (orientation: landscape) {
    .home {
      display: flex;
      flex-direction: row-reverse;

      .tab-box {
        display: flex;
        flex-direction: column;
      }
    }
  }
</style>